module.exports = __webpack_public_path__ + "static/img/0409.a13e181d.png";